import { routes } from "./routes";
import { calendar as reducer, calendarFilters as calendarFiltersReducer } from "./reducer";
import { Calendar } from "./components/Calendar";
import { RoomAndAdminUserCalendar } from "./components/RoomAndAdminUserCalendar";
import { ClinicsCalendar } from "./components/ClinicsCalendar";

export {
    routes,
    Calendar,
    RoomAndAdminUserCalendar,
    ClinicsCalendar,
    reducer,
    calendarFiltersReducer
};
